import { useParams } from "react-router-dom";
import ConditionPageLayout from "@/components/ConditionPageLayout";
import NotFound from "@/pages/NotFound";
import { getCondition } from "@/data/conditions";

const ConditionPage = () => {
  const { slug } = useParams();
  const condition = getCondition(slug);

  if (!condition) return <NotFound />;

  return <ConditionPageLayout condition={condition} />;
};

export default ConditionPage;
